import React from "react";
import { Box, Typography } from "@mui/material";
import { DotLegalFullScreenSpinner, DotLegalPdfBackPage, DotLegalPdfFrontPage } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useSetPdfPageSize } from "@common/pdfPageSizeHelper";

export interface ManagementReportPageProps {
    isLoading: boolean;
    isPdf: boolean;
    groupName: string;
    sender: string;
    deadline: Date | undefined;
    children: React.ReactNode;
}

function ManagementReportPage(props: ManagementReportPageProps) {
    const { translateString, translateDate } = useTranslation();
    useSetPdfPageSize("landscape");

    if (props.isLoading) {
        return <DotLegalFullScreenSpinner />;
    }

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                color: "primary.dark",
                backgroundColor: props.isPdf ? "white" : "#fafafa",
            }}
        >
            <Box
                sx={(theme) => ({
                    width: "100vw",
                    maxWidth: "1300px",
                    [theme.breakpoints.down("sm")]: {
                        maxWidth: "100%",
                    },
                })}
            >
                <DotLegalPdfFrontPage header={props.groupName} subHeader={translateString("managementReport")} isPdf={props.isPdf} backgroundImage={"blue"}>
                    <Box sx={{ marginTop: 9 }}>
                        <Typography sx={{ fontSize: 25 }}>
                            <Box component={"span"} sx={{ fontWeight: 700 }}>
                                {translateString("sentBy")}: &nbsp;
                            </Box>
                            {props.sender}
                        </Typography>

                        <Typography sx={{ fontSize: 25, mt: 2 }}>
                            <Box component={"span"} sx={{ fontWeight: 700 }}>
                                {translateString("deadline")}: &nbsp;
                            </Box>
                            {props.deadline && translateDate(props.deadline)}
                        </Typography>
                    </Box>
                </DotLegalPdfFrontPage>

                <Box p={4} pt={props.isPdf ? 1 : 4} mb={props.isPdf ? 0 : 3} sx={{ backgroundColor: "white" }}>
                    {props.children}
                </Box>

                {props.isPdf && (
                    <Box sx={{ backgroundColor: "white" }} className={"page-break-before"}>
                        <DotLegalPdfBackPage />
                    </Box>
                )}
            </Box>
        </Box>
    );
}

export default ManagementReportPage;
